export default __webpack_public_path__ + "static/media/Gauntlets of the Savage Slaughter.10fc89e3.jpg";